import {
  GetCandidateSourcesDocument,
  UpdateCandidateSourceDocument,
  UpdateCandidateSourceMutation,
  UpdateCandidateSourceMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import type { CandidateSource } from './useCandidateSources'

type Variables = Omit<UpdateCandidateSourceMutationVariables, 'id'>

export const useUpdateCandidateSource = (candidateSource: CandidateSource) => {
  const [updateCandidateSource, { loading }] = useMutation(UpdateCandidateSourceDocument, {
    extractorFn: (data: UpdateCandidateSourceMutation) =>
      data.atsMutations.updateAtsCandidateSource,
  })

  return {
    loading,
    update(variables: Variables) {
      return updateCandidateSource({
        variables: { id: candidateSource.id, ...variables },
        refetchQueries: [GetCandidateSourcesDocument],
      })
    },
  }
}
